<template lang="pug">
    .cell-action-wrapper.overflow-initial(v-show="fullData.type  !== 'NAV'")
        .cell-content.actions
            ActionsMenu(:actions="actions")
</template>

<script>
import { mapActions } from 'vuex'
import ActionsMenu from '@/components/common/ActionsMenu'

export default {
    name: 'CellNamespaceAction',
    props: {
        clickOnCell: {
            type: Function,
            default: () => {}
        },
        data: {
            type: [Function, Array, String, Number],
            default: null
        },
        type: {
            type: String,
            default: ''
        },
        fullData: {
            type: Object,
            default: () => ({})
        }
    },

    components: { ActionsMenu },

    data() {
        return {
            actions: [
                {
                    label: 'delete',
                    action: async () => {
                        await this.handleDeleteNamespace(this.fullData.id)
                    }
                }
            ]
        }
    },
    methods: {
        ...mapActions('account', ['deleteNamespace']),

        handleDeleteNamespace(id) {
            this.deleteNamespace({ id })
        }
    }
}
</script>
